import React, { useState } from "react";
import {
  StandardModal,
  ModalTextField,
  ModalDateField,
  ModalNumberField,
  ModalDropdownField,
  ModalSearchSelectField,
} from "./index";

const SAMPLE_OPTIONS = [
  { value: "a", label: "Apple" },
  { value: "b", label: "Banana" },
  { value: "c", label: "Cherry" },
  { value: "m", label: "Mango" },
  { value: "o", label: "Orange" },
];

/**
 * Showcase page for StandardModal and all field types.
 * Use for manual verification of layout, centering, and field behavior.
 */
export function ModalShowcase() {
  const [showModal, setShowModal] = useState(false);
  const [text, setText] = useState("");
  const [textarea, setTextarea] = useState("");
  const [date, setDate] = useState("");
  const [number, setNumber] = useState<number | undefined>(undefined);
  const [dropdown, setDropdown] = useState("");

  return (
    <div style={{ padding: "2rem" }}>
      <h1>Modal Showcase</h1>
      <p>Use this page to verify layout, centering, and field functionality.</p>
      <button
        onClick={() => setShowModal(true)}
        style={{
          padding: "0.75rem 1.5rem",
          fontSize: "1rem",
          cursor: "pointer",
        }}
      >
        Open Standard Modal
      </button>

      {showModal && (
        <StandardModal
          title="Modal Showcase - All Field Types"
          onClose={() => setShowModal(false)}
          maxWidth="700px"
          actions={{
            primary: {
              label: "Opslaan",
              onClick: () => setShowModal(false),
            },
            secondary: {
              label: "Annuleren",
              onClick: () => setShowModal(false),
            },
          }}
        >
          <div className="modal-form-grid modal-form-grid--2col">
            <ModalTextField
              label="Tekst (kort)"
              value={text}
              onChange={setText}
              placeholder="Korte tekst..."
            />
            <ModalDateField label="Datum" value={date} onChange={setDate} />
          </div>

          <div className="modal-form-grid modal-form-grid--2col">
            <ModalDropdownField
              label="Dropdown (type 'M' to jump)"
              value={dropdown}
              onChange={setDropdown}
              options={SAMPLE_OPTIONS}
              placeholder="Kies optie..."
              sortBy="alpha"
            />
            <ModalNumberField
              label="Getal (geen 0-prefill)"
              value={number}
              onChange={setNumber}
              min={0}
            />
          </div>

          <ModalTextField
            label="Opmerking (textarea)"
            value={textarea}
            onChange={setTextarea}
            placeholder="Optionele opmerking..."
            rows={3}
            maxLength={500}
          />

          <ModalSearchSelectField label="Zoek en selecteer (wrapper)">
            <input
              type="text"
              placeholder="Typ om te zoeken..."
              className="form-input"
              style={{ width: "100%" }}
              readOnly
            />
          </ModalSearchSelectField>
        </StandardModal>
      )}
    </div>
  );
}
